import { FAIconName, FireflyButton } from '@equip.health/ui';

interface ReviewDuplicateDataButtonProps {
  id: string;
  isLoading: boolean;
  onClick: () => void;
}

const ReviewDuplicateDataButton = ({
  id,
  isLoading,
  onClick,
}: ReviewDuplicateDataButtonProps) => (
  <FireflyButton
    id={`${id}-review-duplicates`}
    isDisabled={isLoading}
    onClick={onClick}
    rightIcon={FAIconName.mergeRegular}
    size="small"
    variant="secondary"
  >
    Review duplicates
  </FireflyButton>
);

export default ReviewDuplicateDataButton;
